import { render, staticRenderFns } from "./PayTip.vue?vue&type=template&id=32b5343b&scoped=true&"
import script from "./PayTip.vue?vue&type=script&lang=js&"
export * from "./PayTip.vue?vue&type=script&lang=js&"
import style0 from "./PayTip.vue?vue&type=style&index=0&id=32b5343b&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32b5343b",
  null
  
)

export default component.exports